const prefix = 'WELLNESS_PROGRAM_PAYMENTS_';
export const SET_ACH_UPLOAD_AVAILABILITY = `${prefix}_SET_ACH_UPLOAD_AVAILABILITY`;
export const CHECK_ACH_UPLOAD_AVAILABLE = `${prefix}_CHECK_ACH_UPLOAD_AVAILABLE`;